import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * MetaPixel — initializes the Meta Pixel and tracks PageView on route changes.
 *
 * Pixel ID sourced from VITE_META_PIXEL_ID env var (Vite uses VITE_ prefix, not NEXT_PUBLIC_).
 * Set in Vercel project settings: VITE_META_PIXEL_ID = <pixel_id_from_meta_business_manager>
 *
 * Conversion events:
 *   - PageView: fired on every route change (auto)
 *   - ViewContent: fired on /demo page load (see DemoPage.jsx)
 *   - Lead: fired on Calendly booking completion (via Calendly event listener in DemoPage.jsx)
 */
const MetaPixel = () => {
    const location = useLocation();
    const pixelId = import.meta.env.VITE_META_PIXEL_ID;

    useEffect(() => {
        if (!pixelId) {
            console.warn('[MetaPixel] VITE_META_PIXEL_ID not set — pixel disabled');
            return;
        }

        // Initialize pixel once
        if (window.fbq) {
            window.fbq('init', pixelId);
        }
    }, [pixelId]);

    // Track PageView on every route change
    useEffect(() => {
        if (!pixelId || !window.fbq) return;
        window.fbq('track', 'PageView');
    }, [location.pathname, pixelId]);

    return null;
};

export default MetaPixel;
